var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetwork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.9994 0.666672C5.13273 0.666672 2.5194 1.73334 0.526064 3.49334C0.232731 3.75334 0.212731 4.20001 0.486064 4.47334L7.52606 11.5267C7.78606 11.7867 8.20606 11.7867 8.47273 11.5267L15.5127 4.47334C15.7861 4.20001 15.7661 3.75334 15.4727 3.49334C13.4794 1.73334 10.8661 0.666672 7.9994 0.666672ZM7.9994 3.33334C6.09273 3.33334 4.33273 3.96001 2.8994 5.00667L1.94606 4.04667C3.67273 2.72001 5.7794 2.00001 7.9994 2.00001C10.2194 2.00001 12.3261 2.72001 14.0527 4.04667L13.0994 5.00001C11.6661 3.96001 9.90606 3.33334 7.9994 3.33334Z",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.575934af689eac9dc0a8724818615cef.svg";
export { ForwardRef as ReactComponent };